export interface DimensionsHeight {
  Quantity: number;
  Units: string;
}

export const DEFAULT_FOLDER_TILE_HEIGHT_QUANTITY = 5;
export const DEFAULT_FOLDER_TILE_HEIGHT_UNITS = 'tiles'

export const DEFAULT_DATA_POINT_FOLDER_VIEW_ITEM_PX_HEIGHT = 68;

//
export class TileDimensions {
  Height: DimensionsHeight = {
    Quantity: DEFAULT_FOLDER_TILE_HEIGHT_QUANTITY,
    Units: DEFAULT_FOLDER_TILE_HEIGHT_UNITS
  }

  constructor(quantity?: number, units?: string) {
    if (!!quantity) {
      this.Height.Quantity = quantity
    }
    if (!!units) {
      this.Height.Units = units
    }
  }
}
